import useRetrieveData from 'global/hooks/useRetrieveData';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';

export const useVendors = (realmId, opts = {}) => {
  opts = {
    include: 'realms,client,vendor,editions,scorecards',
    ...opts,
  };

  const meRealm = useSelector((state) => get(state, 'auth.user.realm'));
  const realm_id = realmId || get(meRealm, 'id');

  const resp = useRetrieveData(
    { url: `/client-vendors` },
    {
      build: ['clientVendors'],
      useCache: { reload: 20 },
      params: { include: opts.include },
      ...opts,
    }
  );

  return {
    ...resp,
    data: [opts.includeUsersRealm ? { id: -1, vendorId: get(meRealm, 'id'), clientId: -1, vendor: meRealm } : null, ...(resp.data || []).filter((v) => `${v.vendorId}` !== `${realm_id}`)].filter(
      (f) => f
    ),
  };
};

export const useClients = (realmId, user_id, opts = {}) => {
  opts = {
    include: 'realms,client,vendor,editions,scorecards',
    ...opts,
  };

  const meRealmId = useSelector((state) => get(state, 'auth.user.realm.id'));
  const realm_id = realmId || meRealmId;
  return useRetrieveData(
    { url: `/client-vendors` },
    {
      useEffect: true,
      build: ['clientVendors'],
      useCache: { reload: 20 },
      params: {
        include: opts.include,
        filter: { vendor_id: realm_id, user_id },
      },
      ...opts,
    }
  );
};
